import {
  ADMIN_MONETIZATION_REQUESTS_LOADED,
  ADMIN_MONETIZATION_REQUESTS_CLEAR,
  ADMIN_MONETIZATION_REQUEST_DETAILS_LOADED,
  ADMIN_MONETIZATION_REQUEST_DETAILS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  requests: null,
  details: null,
};

function monetizationRequests(state = initialState, action) {
  switch (action.type) {
    case ADMIN_MONETIZATION_REQUESTS_LOADED:
      return { ...state, requests: action.payload.requests };
    case ADMIN_MONETIZATION_REQUESTS_CLEAR:
      return { ...state, requests: null };
    case ADMIN_MONETIZATION_REQUEST_DETAILS_LOADED:
      return { ...state, details: action.payload.details };
    case ADMIN_MONETIZATION_REQUEST_DETAILS_CLEAR:
      return { ...state, details: null };
    default:
      return state;
  }
}

export default monetizationRequests;
